import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { OnlyNumbersFloatDirective } from './directives/inputs/only-numbers-float.directive';
import { ValidateZeroInputDirective } from './directives/inputs/validate-zero-input.directive';
import { PrinterService } from './services/printer.service';
import { OnlyNumbersNegativeFloatDirective } from './directives/inputs/only-numbers-negative-float.directive';
import { ButtonsHoverTableDirective } from './directives/tables/buttons-hover-table.directive';



@NgModule({
  imports: [
    CommonModule,
    ComponentsModule
  ],
  exports:[
    ComponentsModule,
    OnlyNumbersFloatDirective,
    OnlyNumbersNegativeFloatDirective,
    ValidateZeroInputDirective,
    ButtonsHoverTableDirective
  ],
  declarations: [
    OnlyNumbersFloatDirective,
    OnlyNumbersNegativeFloatDirective,
    ValidateZeroInputDirective,
    ButtonsHoverTableDirective
  ],
  providers: [
    PrinterService
  ]
})
export class SharedModule { }
